import { ICON } from "../../../components/Icon/data";
import i18n from "../../../i18n";
import { removeServiceInstance } from "../../../services/calls/maintenance";
import { MAINTENANCE_FIELDS } from "./modal/data";
import { INSTANCE_COLUMNS } from "./table/data";
import { saveScheduleInstance } from "./utils";

export const BASE_COLUMNS = [
  MAINTENANCE_FIELDS.SERVICE_NAME, MAINTENANCE_FIELDS.EDIT_NOTE, MAINTENANCE_FIELDS.KM_INTERVAL,
  MAINTENANCE_FIELDS.FIRST_SERVICE, MAINTENANCE_FIELDS.NEXT_SCHEDULED_DATE, MAINTENANCE_FIELDS.ADD_MONTH_INTERVAL,
  MAINTENANCE_FIELDS.MONTH_INTERVAL, MAINTENANCE_FIELDS.NEXT_SCHEDULED_SERVICE_DATE,
  MAINTENANCE_FIELDS.ESTIMATED_DURATION, MAINTENANCE_FIELDS.COMMENT, MAINTENANCE_FIELDS.EMAIL 
]

export const MAINTENANCE_DATA = {
  milage: {
    label: i18n.t('Check schedule based on milage'),
    idKey: 'id',
    icon: ICON.ANNOTATION_VISIBILITY,
    description: i18n.t('This is your regular service based on time and/or milage of the vehicle'),
    tableColumns: [
      INSTANCE_COLUMNS.KM, INSTANCE_COLUMNS.KM_INSTANCE
    ],
    modalFields: [
      MAINTENANCE_FIELDS.SERVICE_NAME, MAINTENANCE_FIELDS.NOT_PERFORMED, MAINTENANCE_FIELDS.DATE,
      MAINTENANCE_FIELDS.ODOMETER_READING, MAINTENANCE_FIELDS.SERVICE_DURATION, MAINTENANCE_FIELDS.SERVICE_COST,
      MAINTENANCE_FIELDS.COMMENT, MAINTENANCE_FIELDS.FILES
    ],
    saveFunction: (data: any, id?: number, oldData?: any) => saveScheduleInstance(data, id, oldData),
    deleteFunction: (id: number) => removeServiceInstance(id)
  },
  date: {
    label: i18n.t('Check schedule based on date only'),
    idKey: 'id',
    icon: ICON.CALENDAR_TOOLS,
    description: i18n.t('This is your regular service based on time only'),
    tableColumns: [
      INSTANCE_COLUMNS.MONTH, INSTANCE_COLUMNS.MONTH_INSTANCE
    ],
    modalFields: [
      MAINTENANCE_FIELDS.SERVICE_NAME, MAINTENANCE_FIELDS.NOT_PERFORMED, MAINTENANCE_FIELDS.DATE,
      MAINTENANCE_FIELDS.ODOMETER_READING, MAINTENANCE_FIELDS.SERVICE_DURATION, MAINTENANCE_FIELDS.SERVICE_COST,
      MAINTENANCE_FIELDS.COMMENT, MAINTENANCE_FIELDS.FILES
    ],
    saveFunction: (data: any, id?: number, oldData?: any) => saveScheduleInstance(data, id, oldData),
    deleteFunction: (id: number) => removeServiceInstance(id)
  },
  single: {
    label: i18n.t('Single instance'),
    idKey: 'id',
    icon: ICON.VEHICLE_SERVICE,
    description: i18n.t('This is your log for unplanned maintenance'),
    tableColumns: [
      INSTANCE_COLUMNS.SERVICE, INSTANCE_COLUMNS.ODOMETER, INSTANCE_COLUMNS.COST
    ],
    modalFields: [
      MAINTENANCE_FIELDS.SERVICE_NAME, MAINTENANCE_FIELDS.DATE, MAINTENANCE_FIELDS.ODOMETER_READING,
      MAINTENANCE_FIELDS.SERVICE_DURATION, MAINTENANCE_FIELDS.SERVICE_COST, MAINTENANCE_FIELDS.COMMENT,
      MAINTENANCE_FIELDS.FILES
    ],
    saveFunction: (data: any, id?: number, oldData?: any) => saveScheduleInstance(data, id, oldData),
    deleteFunction: (id: number) => removeServiceInstance(id)
  }
}
